import React, { useMemo } from 'react';
import classNames from 'classnames';
import { ItemWithTranslation, SportsLiveSection } from 'types/swagger';
import { isTruthy } from 'utility/functions';
import styles from './ScommesseAvvenimentoScore.module.scss';

export type ScommesseAvvenimentoScoreProps = Pick<Partial<SportsLiveSection>, 'score' | 'server'> & {
  className?: string;
};

export const ScommesseAvvenimentoScore = ({ score, server, className }: ScommesseAvvenimentoScoreProps) => {
  const { sets, scores, points } = useMemo(() => {
    const sets: Array<ItemWithTranslation<{ set: string }>> = [];
    const scores: Array<ItemWithTranslation<{ score?: string }>> = [];
    const points: Array<ItemWithTranslation<{ point?: string }>> = [];

    const { firstCompetitorPoint: point1, secondCompetitorPoint: point2 } = score ?? {};
    if (point1) {
      points.push({ point: point1 });
    }
    if (point2) {
      points.push({ point: point2 });
    }

    // TODO: when SportsLiveScore is update, update descruturing
    const { firstCompetitor: score1, secondCompetitor: score2, lastSetScore } = score ?? {};
    if (score1) {
      scores.push({ score: score1, scoreTrKey: undefined });
    }
    if (score2) {
      scores.push({ score: score2, scoreTrKey: undefined });
    }

    const { firstCompetitor, secondCompetitor } = lastSetScore ?? {};
    if (firstCompetitor) {
      sets.push({ set: firstCompetitor });
    }
    if (secondCompetitor) {
      sets.push({ set: secondCompetitor });
    }

    return {
      sets,
      scores,
      points,
    };
  }, [score]);

  return (
    <div className={classNames(styles.container, className)}>
      <ul className={classNames(styles.pointList, { [styles.emptyList]: points.length === 0 })}>
        {isTruthy(points.length) &&
          points.map(({ point }, index) => (
            <li key={`point_${score}_${index}`} className={classNames(styles.pointItem)}>
              {point}
            </li>
          ))}
      </ul>
      <ul className={classNames(styles.setList, { [styles.emptyList]: sets.length === 0 })}>
        {isTruthy(sets.length) &&
          sets.map(({ set }, index) => (
            <li
              key={`set_${set}_${index}`}
              className={classNames(styles.setItem, { [styles.active]: server && index === server - 1 })}
            >
              {set}
            </li>
          ))}
      </ul>
      <ul className={classNames(styles.scoreList, { [styles.hasMargin]: !isTruthy(sets.length) })}>
        {isTruthy(scores.length) &&
          scores.map(({ score }, index) => (
            <li key={`score_${score}_${index}`} className={styles.scoreItem}>
              {score}
            </li>
          ))}
      </ul>
    </div>
  );
};